import { reatomAsync, withAbort } from "@reatom/async";
import { API } from "src/api";

export const getCountProductSampleRequest = reatomAsync(
  async (ctx, selectionId: number) => {
    return API.productSamplesApi.productSelectionControllerGetProductsCount(
      { selectionId },
      {
        signal: ctx.controller.signal,
      },
    );
  },
  {
    name: "getCountProductSampleRequest",
  },
).pipe(withAbort());
